import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from '../lib/redux-router';

import entryActions from '../entry-actions';
import UnclosedTasksModal from '../components/UnclosedTasksModal';
import selectors from '../selectors';
import ModalTypes from '../constants/ModalTypes';
import Paths from '../constants/Paths';

const mapStateToProps = (state) => {
  const currentModal = selectors.selectCurrentModal(state);
  const modalData = selectors.selectCurrentModalData(state) || {};
  const unclosedTasks = modalData.unclosedTasks || [];

  return {
    open: currentModal === ModalTypes.UNCLOSED_TASKS,
    unclosedTasks,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClose: entryActions.closeModal,
      onCardClick: (cardId) => push(Paths.CARDS.replace(':id', cardId)),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(UnclosedTasksModal);
